import { render, staticRenderFns } from "./RiasecOverviewCharts.vue?vue&type=template&id=322ff6a2&scoped=true&"
import script from "./RiasecOverviewCharts.vue?vue&type=script&lang=js&"
export * from "./RiasecOverviewCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322ff6a2",
  null
  
)

export default component.exports